import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { switchMap, map, catchError, filter } from 'rxjs/operators';
import * as fromScheduledDateActions from './schedule-date.actions';
import { ScheduledDateService } from '../schedule-date.service';
import { of } from 'rxjs';
import * as fromShared from '../../shared';
import { ResponseStatus } from '../../shared';

@Injectable()
export class ScheduledDateEffects {
    constructor(
        private actions$: Actions,
        private service: ScheduledDateService
    ) {}

    getScheduledDates$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(fromScheduledDateActions.getScheduledDates),
            switchMap(action =>
                this.service.get(action.ShowAll).pipe(
                    map(x => x || []),
                    map(data =>
                        fromScheduledDateActions.addScheduledDates({
                            scheduledDates: data
                        })
                    ),
                    catchError(error =>
                        of(
                            fromScheduledDateActions.getScheduledDatesFailure({
                                error
                            })
                        )
                    )
                )
            )
        );
    });

    getScheduledDatesFailure$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(fromScheduledDateActions.getScheduledDatesFailure),
            map(
                a =>
                    new fromShared.Errors.SetErrors(
                        a.error &&
                            a.error.ErrorMessages &&
                            Array.isArray(a.error.ErrorMessages) &&
                            a.error.ErrorMessages.map(e => ({
                                StatusCode: ResponseStatus.Failed,
                                Message: e
                            }))
                    )
            )
        );
    });
}
